import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { justForSideEffect } from 'src/infrastructure/saga.helpers'
import { Product } from '../types'
import { StockListFilters, StockListState } from './StockListTypes'

const initialState: StockListState = {
  stock: [],
  filters: {
    barcode: '',
    code: '',
    fulfillmentCenterId: 0,
    modelId: 0,
    description: '',
  },
  page: 1,
  totalItems: 0,
}

const getStock = justForSideEffect()

const addStock = (state: StockListState, action: PayloadAction<Product[]>) => ({
  ...state,
  stock: [...state.stock, ...action.payload],
})

const clearStock = (state: StockListState) => ({
  ...state,
  stock: initialState.stock,
})

const setFilters = (state: StockListState, action: PayloadAction<StockListFilters>) => ({
  ...state,
  filters: action.payload,
})

const clearFilters = (state: StockListState) => ({
  ...state,
  filters: initialState.filters,
})

const nextPage = (state: StockListState) => ({
  ...state,
  page: state.page + 1,
})

const resetPage = (state: StockListState) => ({
  ...state,
  page: 1,
})

const setTotalItems = (state: StockListState, action: PayloadAction<number>) => ({
  ...state,
  totalItems: action.payload,
})

const slice = createSlice({
  name: 'stockList',
  initialState,
  reducers: {
    addStock,
    clearStock,
    getStock,
    nextPage,
    resetPage,
    setFilters,
    clearFilters,
    setTotalItems,
  },
})

export default slice.reducer

export const { actions } = slice
